<template>
  <Overlay
    :autoHeight="true"
    width="x-small"
    :link="{
      name: 'list',
      params: {
        companyId: this.companyId,
        siteId: this.siteId,
        pageId: this.pageId
      }
    }"
  >
    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"
      :withinOverlay="true"
    />

    <div class="page-edit-list">
      <EditListForm
        v-model="list"
        :listTypes="listTypeOptions"
        :errors="errors"
        @submit="submitList"
      />
    </div>
  </Overlay>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {
  readCompanySitePageListData,
  updateCompanySitePageListData
} from '@/lib/lists'
import {readListTypesData} from '@/lib/list_types'

import EditListForm from '@/components/forms/EditListForm'
import Overlay from '@/components/Overlay'

export default {
  name: 'ListItem',

  props: {
    companyId: {
      type: String,
      required: true
    },

    siteId: {
      type: String,
      required: true
    },

    pageId: {
      type: String,
      required: true
    },

    listId: {
      type: String,
      required: true
    }
  },

  mixins: [page, notification],

  components: {
    EditListForm,
    Overlay
  },

  data() {
    return {
      list: {},
      errors: {},
      listTypes: []
    }
  },

  computed: {
    listTypeOptions() {
      return this.listTypes.map((type) => {
        return {
          key: type.name,
          value: type.id
        }
      })
    },

    title() {
      return `Editing ${this.list.name} List`
    }
  },

  methods: {
    getData() {
      readCompanySitePageListData(
        this.companyId,
        this.siteId,
        this.pageId,
        this.listId
      ).then(({data}) => {
        this.list = data
      })

      readListTypesData().then(({data}) => {
        this.listTypes = data
      })
    },

    submitList() {
      updateCompanySitePageListData(
        this.companyId,
        this.siteId,
        this.pageId,
        this.listId,
        this.list
      )
        .then(({data}) => {
          this.triggerNotification('success', 'section', 'updated')
          this.$emit('updatePage')

          window.setTimeout(() => {
            this.$router.push({
              name: 'list',
              params: {
                companyId: this.companyId,
                listId: this.listId,
                siteId: this.siteId
              }
            })
          }, 2000)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="sass">
.page-edit-list
</style>
